"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_APP_KEYS_AUDIT_ACTION = exports.SOCIAL_APP_KEYS_AUDIT_ENTITY = exports.INSTAGRAM_LOGIN_UNAVAILABLE = exports.SOCIAL_APP_KEYS_NOT_SET = exports.LINKEDIN_API_TYPE_OF_SET = exports.LINKEDIN_CREDENTIAL_SET = exports.LINKEDIN_COMMUNITY_SCOPE = exports.SOCIAL_CREDENTIAL_SET_INFO = exports.SOCIAL_CREDENTIAL_SETS = void 0;
exports.isSocialCredentialSet = isSocialCredentialSet;
exports.linkedinApiTypeOf = linkedinApiTypeOf;
exports.credentialSetsForPlatform = credentialSetsForPlatform;
exports.credentialSetFor = credentialSetFor;
exports.credentialSetOfConnection = credentialSetOfConnection;
exports.socialKeysNoticeName = socialKeysNoticeName;
exports.socialKeysNotSetUp = socialKeysNotSetUp;
exports.bothKeysRequired = bothKeysRequired;
const enums_1 = require("./enums");
const social_1 = require("./social");
/** Every set, in the order Site Integrations lists them. */
exports.SOCIAL_CREDENTIAL_SETS = [
    'LINKEDIN_COMMUNITY',
    'LINKEDIN_SHARE',
    'FACEBOOK',
    'THREADS',
    'X',
];
/** Whether a value (a route parameter, a stored audit entity id) names a credential set. */
function isSocialCredentialSet(value) {
    return typeof value === 'string' && exports.SOCIAL_CREDENTIAL_SETS.includes(value);
}
/** The copy and wiring of each set, word for word as Site Integrations shows it. */
exports.SOCIAL_CREDENTIAL_SET_INFO = {
    LINKEDIN_COMMUNITY: {
        platform: enums_1.SocialPlatform.LINKEDIN,
        rowName: 'LinkedIn · Community Management',
        subtext: 'Connect Company Pages',
        footnote: null,
        name: 'LinkedIn Community Management',
        signInName: 'LinkedIn',
        idLabel: 'LinkedIn Client ID',
        idPlaceholder: 'e.g. 86xxxxxxxxxxxx',
        secretLabel: 'LinkedIn Client Secret',
        secretPlaceholder: 'Paste your Client Secret',
        consolePath: 'Auth → Authorized redirect URLs',
        infoNote: 'Requires the Community Management API product approved on this LinkedIn app.',
        guidePath: '/guide/linkedin-app',
        redirectKey: 'linkedin',
    },
    LINKEDIN_SHARE: {
        platform: enums_1.SocialPlatform.LINKEDIN,
        rowName: 'LinkedIn · Sign In + Share',
        subtext: 'Post as a member',
        footnote: null,
        name: 'LinkedIn Sign In + Share',
        signInName: 'LinkedIn',
        idLabel: 'LinkedIn Client ID',
        idPlaceholder: 'e.g. 86xxxxxxxxxxxx',
        secretLabel: 'LinkedIn Client Secret',
        secretPlaceholder: 'Paste your Client Secret',
        consolePath: 'Auth → Authorized redirect URLs',
        infoNote: 'Use a separate LinkedIn app from Community Management, with the Sign In with LinkedIn and Share on LinkedIn products enabled.',
        guidePath: '/guide/linkedin-app',
        redirectKey: 'linkedin',
    },
    FACEBOOK: {
        platform: enums_1.SocialPlatform.FACEBOOK,
        rowName: 'Facebook',
        subtext: null,
        footnote: 'This app is also used to connect Instagram, which currently signs in through Facebook.',
        name: 'Facebook',
        signInName: 'Facebook',
        idLabel: 'Facebook App ID',
        idPlaceholder: 'e.g. 1004448652261197',
        secretLabel: 'Facebook App Secret',
        secretPlaceholder: 'Paste your App Secret',
        consolePath: 'Facebook Login → Settings → Valid OAuth Redirect URIs',
        infoNote: null,
        guidePath: '/guide/facebook-app',
        redirectKey: 'facebook',
    },
    THREADS: {
        platform: enums_1.SocialPlatform.THREADS,
        rowName: 'Threads',
        subtext: null,
        footnote: null,
        name: 'Threads',
        signInName: 'Threads',
        idLabel: 'Threads App ID',
        idPlaceholder: 'e.g. 2468xxxxxxxxxx',
        secretLabel: 'Threads App Secret',
        secretPlaceholder: 'Paste your App Secret',
        consolePath: 'Use cases → Threads API → Settings → Redirect Callback URLs',
        infoNote: null,
        guidePath: '/guide/connect/threads',
        redirectKey: 'threads',
    },
    X: {
        platform: enums_1.SocialPlatform.X,
        rowName: 'X / Twitter',
        subtext: null,
        footnote: null,
        name: 'X / Twitter',
        signInName: 'X / Twitter',
        idLabel: 'Client ID',
        idPlaceholder: 'e.g. WjJ4xxxxxxxxxxxxxxx',
        secretLabel: 'Client Secret',
        secretPlaceholder: 'Paste your Client Secret',
        consolePath: 'User authentication settings → Callback URI / Redirect URL',
        infoNote: 'Set up OAuth 2.0 with a Confidential client (Web App) and Read and write permissions.',
        guidePath: '/guide/connect/x',
        redirectKey: 'x',
    },
};
// ── Which set a connection signs in with ──────────────────────────────────
/** The permission only a Community Management (Company Page) LinkedIn connection holds. */
exports.LINKEDIN_COMMUNITY_SCOPE = 'w_organization_social';
/**
 * A stored LinkedIn connection's API type: Community Management when its scopes hold
 * {@link LINKEDIN_COMMUNITY_SCOPE}, Sign In + Share otherwise. The whole name has to match
 * ({@link hasScope}): a longer scope that merely contains those letters is not it.
 */
function linkedinApiTypeOf(scopes) {
    return (0, social_1.hasScope)(scopes, exports.LINKEDIN_COMMUNITY_SCOPE) ? 'community' : 'standard';
}
/** The set each LinkedIn connection type signs in with: one app per type. */
exports.LINKEDIN_CREDENTIAL_SET = {
    community: 'LINKEDIN_COMMUNITY',
    standard: 'LINKEDIN_SHARE',
};
/** The other way round: the LinkedIn connection type a LinkedIn set serves. */
exports.LINKEDIN_API_TYPE_OF_SET = {
    LINKEDIN_COMMUNITY: 'community',
    LINKEDIN_SHARE: 'standard',
};
/**
 * The sets a NEW connection on `platform` could need: LinkedIn both (one per connection type),
 * Instagram the Facebook one (it signs in through Facebook), YouTube Shorts none.
 */
function credentialSetsForPlatform(platform) {
    switch (platform) {
        case enums_1.SocialPlatform.LINKEDIN:
            return ['LINKEDIN_COMMUNITY', 'LINKEDIN_SHARE'];
        case enums_1.SocialPlatform.FACEBOOK:
        case enums_1.SocialPlatform.INSTAGRAM:
            return ['FACEBOOK'];
        case enums_1.SocialPlatform.THREADS:
            return ['THREADS'];
        case enums_1.SocialPlatform.X:
            return ['X'];
        default:
            return [];
    }
}
/** The set a NEW connection signs in with. LinkedIn needs its connection type (null without one). */
function credentialSetFor(platform, linkedinApiType) {
    if (platform === enums_1.SocialPlatform.LINKEDIN) {
        return linkedinApiType ? exports.LINKEDIN_CREDENTIAL_SET[linkedinApiType] : null;
    }
    return credentialSetsForPlatform(platform)[0] ?? null;
}
/**
 * THE ONE RULE for which set an EXISTING connection's Reconnect - and its "Turn on" / "Enable
 * threads" - signs in with. The API's reconnect and the connection DTO both call this, so the
 * Connections page's gating cannot disagree with the server's guard.
 *
 * - LinkedIn: the set of the type it was connected as ({@link linkedinApiTypeOf}).
 * - Instagram: the Facebook set when it was connected through Facebook Login; null when it was
 *   connected with Instagram Login - it keeps reconnecting with its own stored app.
 * - Every other platform: {@link credentialSetFor}; null for one with no reconnect flow (YouTube Shorts).
 */
function credentialSetOfConnection(platform, scopes) {
    if (platform === enums_1.SocialPlatform.LINKEDIN)
        return exports.LINKEDIN_CREDENTIAL_SET[linkedinApiTypeOf(scopes)];
    if (platform === enums_1.SocialPlatform.INSTAGRAM)
        return (0, social_1.instagramLoginType)(scopes) === 'facebook' ? 'FACEBOOK' : null;
    return credentialSetFor(platform);
}
/** The <Platform> a not-set-up notice names: Instagram for an Instagram connection, else the set's name. */
function socialKeysNoticeName(set, platform) {
    return platform === enums_1.SocialPlatform.INSTAGRAM
        ? social_1.socialPlatformLabel[enums_1.SocialPlatform.INSTAGRAM]
        : exports.SOCIAL_CREDENTIAL_SET_INFO[set].name;
}
/** Said by the Connections page AND by the server's refusal (409) while a set has no keys. */
function socialKeysNotSetUp(name, audience) {
    return audience === 'admin'
        ? `${name} API connection hasn't been set up yet. Add the app keys in Site Integrations so users can connect their accounts.`
        : `${name} API connection hasn't been set up yet. Contact your administrator to add the app keys in Site Integrations.`;
}
/** A first save without both values: said by the form and by the server (400). */
function bothKeysRequired(set) {
    const info = exports.SOCIAL_CREDENTIAL_SET_INFO[set];
    return `Enter both the ${info.idLabel} and the ${info.secretLabel}.`;
}
/** The `error` of the server's 409 when a start or reconnect needs a set that has no keys. */
exports.SOCIAL_APP_KEYS_NOT_SET = 'SOCIAL_APP_KEYS_NOT_SET';
/** The `error` of the server's 400 for a NEW Instagram Login connection, which can no longer start. */
exports.INSTAGRAM_LOGIN_UNAVAILABLE = 'INSTAGRAM_LOGIN_UNAVAILABLE';
/** The audit entity of a key change; its entity id is the set. */
exports.SOCIAL_APP_KEYS_AUDIT_ENTITY = 'SocialAppKeys';
/** The audit actions of a key change. Their diffs carry markers only, never a value. */
exports.SOCIAL_APP_KEYS_AUDIT_ACTION = {
    added: 'social-app-keys.add',
    replaced: 'social-app-keys.replace',
    removed: 'social-app-keys.remove',
};
//# sourceMappingURL=social-app-keys.js.map